<div class="row">
  <div class="col-md-9">
    <div class="card">
      <div class="card-header text-header">
        <span class="fa fa-list"></span> Summary Details
      </div>
      <app-progress-bar [isLoading]="isLoadingRegDetail"></app-progress-bar>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-md-2">Change ID</div>
          <div class="col-md-4">
            {{ regulation.id }}
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-2">Title</div>
          <div class="col-md-6">
            {{ regulation.title }}
          </div>
        </div>
        <hr />
        <div class="row mt-3">
          <div class="col-md-12 col-lg-3">
            <div class="form-group">
              <div class="left inline label-heading control-label mb-1">
                Geography
              </div>
              <div class="input-group">
                <input
                  type="text"
                  id="SerachText"
                  class="form-control form-control-sm"
                  value="{{ regulation.geography }}"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-3">
            <div class="form-group">
              <div class="left inline label-heading control-label mb-1">
                Country
              </div>
              <input
                type="text"
                id="SerachText"
                class="form-control form-control-sm"
                value="{{ regulation.country }}"
                readonly
              />
            </div>
          </div>
          <div class="col-md-12 col-lg-3">
            <div class="left inline label-heading control-label mb-1">
              Regulator
            </div>
            <input
              type="text"
              class="small-text-gray form-control form-control-sm"
              value="{{ regulation.regulator }}"
              readonly
            />
          </div>
        </div>
      </div>
    </div>
    <!--card-->
    <hr />

    <div class="card">
      <div class="card-header text-header">
        <span class="fa fa-list"></span> Additional Details
      </div>
      <div class="card-body">
        <div class="row mt-2">
          <div class="col-md-12 col-lg-3">
            <div class="form-group">
              <div class="left inline label-heading control-label mb-1">
                Date
              </div>
              <div class="input-group input-group-sm">
                <input
                  class="form-control form-control-sm"
                  value="{{ regulation.date }}"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-3">
            <div class="form-group">
              <div class="left inline label-heading control-label mb-1">
                Type
              </div>
              <input
                type="text"
                id="SerachText"
                class="form-control form-control-sm"
                value="{{ regulation.pubType }}"
                readonly
              />
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="form-group">
              <div class="left inline label-heading control-label mb-1">
                Topic
              </div>

              <ng-container
                *ngIf="
                  regulation.ruleTopic && regulation.ruleTopic.length > 65;
                  else tooltipTopics
                "
              >
                <ng-template #popTemplate>
                  <span class="pull-right tooltip-close" (click)="Close()"
                    >x</span
                  >
                  <div
                    [innerHtml]="ruleTopicsForToolTip"
                    (mouseout)="Close()"
                  ></div>
                </ng-template>
                <input
                  type="text"
                  [value]="regulation.ruleTopic"
                  triggers="mouseenter"
                  class="form-control form-control-sm"
                  [tooltip]="popTemplate"
                  placement="left"
                  container="body"
                  readonly
                />
              </ng-container>
              <ng-template #tooltipTopics>
                <input
                  type="text"
                  [value]="regulation.ruleTopic"
                  class="form-control form-control-sm"
                  readonly
                />
              </ng-template>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-4 col-md-8">
              <div class="left inline label-heading control-label mb-1">
                Description
              </div>
            </div>
            <div class="col-8 col-md-4 text-right">
              <a
                href="{{ regulation.hyperlink }}"
                target="_blank"
                [ngClass]="regulation.hyperlink ? '' : 'disabled'"
              >
                <span class="fa fa-globe"></span>
                View Website Link
              </a>
            </div>
          </div>
          <textarea
            class="form-control form-control-sm"
            id="exampleFormControlTextarea1"
            rows="3"
            readonly
            >{{ regulation.description }}</textarea
          >
        </div>
      </div>
    </div>
    <hr />

    <div class="card">
      <div class="card-header text-header">
        <span class="fa fa-list"></span> Action Manager
      </div>
      <app-progress-bar [isLoading]="isSubmitting"></app-progress-bar>
      <div class="card-body">
        <form
          role="form"
          [formGroup]="actionManagerForm"
          #formData="ngForm"
          (ngSubmit)="onSubmit()"
        >
          <div class="row mt-2">
            <div class="col-md-12 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Type</div>
                <input
                  type="text"
                  class="form-control form-control-sm mat-autodd-input"
                  formControlName="type"
                  matInput
                  [matAutocomplete]="actionTypeAuto"
                  required
                />
                <mat-autocomplete #actionTypeAuto="matAutocomplete">
                  <mat-option
                    *ngFor="let option of searchedActionTypes"
                    [value]="option.value"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
                <small
                  class="text-danger col-md-12 p-0 mt-2"
                  *ngIf="
                    !actionManagerForm.controls['type'].value &&
                    actionManagerForm.controls['type'].touched
                  "
                >
                  Type is a required field
                </small>
              </div>
            </div>

            <div class="col-md-12 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Topic</div>
                <input
                  type="text"
                  class="form-control form-control-sm mat-autodd-input"
                  formControlName="topic"
                  matInput
                  [matAutocomplete]="topicAuto"
                  required
                />
                <mat-autocomplete #topicAuto="matAutocomplete">
                  <mat-option
                    *ngFor="let option of searchedTopics"
                    [value]="option.value"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
                <small
                  class="text-danger col-md-12 p-0 mt-2"
                  *ngIf="
                    !actionManagerForm.controls['topic'].value &&
                    actionManagerForm.controls['topic'].touched
                  "
                >
                  Topic is a required field
                </small>
              </div>
            </div>

            <div class="col-md-12 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Impact Area</div>
                <input
                  formControlName="impactArea"
                  type="text"
                  class="form-control form-control-sm mat-autodd-input"
                  matInput
                  [matAutocomplete]="impactAreaAuto"
                  required
                />
                <mat-autocomplete #impactAreaAuto="matAutocomplete">
                  <mat-option
                    *ngFor="let option of searchedImpactAreas"
                    [value]="option.value"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
                <small
                  class="text-danger col-md-12 p-0 mt-2"
                  *ngIf="
                    !actionManagerForm.controls['impactArea'].value &&
                    actionManagerForm.controls['impactArea'].touched
                  "
                >
                  Impact Area is a required field
                </small>
              </div>
            </div>
            <div class="col-md-12 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Status</div>
                <input
                  type="text"
                  class="form-control form-control-sm mat-autodd-input"
                  formControlName="status"
                  matInput
                  [matAutocomplete]="statusAuto"
                  required
                />
                <mat-autocomplete #statusAuto="matAutocomplete">
                  <mat-option
                    *ngFor="let option of searchedStatus"
                    [value]="option.value"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
                <small
                  class="text-danger col-md-12 p-0 mt-2"
                  *ngIf="
                    !actionManagerForm.controls['status'].value &&
                    actionManagerForm.controls['status'].touched
                  "
                >
                  Status is a required field
                </small>
              </div>
            </div>
            <div class="col-md-12 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Action Date</div>
                <div class="input-group input-group-sm">
                  <input
                    formControlName="actionDate"
                    matInput
                    [matDatepicker]="actionDateFrom"
                    (click)="actionDateFrom.open()"
                    placeholder="Choose a date"
                    class="form-control form-control-sm"
                    id="actionDateFrom"
                    placeholder="From"
                    required
                    readonly
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text fa fa-calendar"
                      (click)="actionDateFrom.open()"
                    ></span>
                  </div>
                </div>
                <mat-datepicker #actionDateFrom></mat-datepicker>
                <small
                  class="text-danger col-md-12 p-0 mt-2"
                  *ngIf="
                    !actionManagerForm.controls['actionDate'].value &&
                    actionManagerForm.controls['actionDate'].touched
                  "
                >
                  Action Date is a required field
                </small>
              </div>
            </div>

            <div class="col-md-12 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Effective Date</div>
                <div class="input-group input-group-sm">
                  <input
                    formControlName="effectiveDate"
                    matInput
                    [matDatepicker]="effectiveDateFrom"
                    (click)="effectiveDateFrom.open()"
                    placeholder="Choose a date"
                    class="form-control form-control-sm"
                    id="effectiveDateFrom"
                    placeholder="From"
                    required
                    readonly
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text fa fa-calendar"
                      (click)="effectiveDateFrom.open()"
                    ></span>
                  </div>
                </div>
                <mat-datepicker #effectiveDateFrom></mat-datepicker>
                <small
                  class="text-danger col-md-12 p-0 mt-2"
                  *ngIf="
                    !actionManagerForm.controls['effectiveDate'].value &&
                    actionManagerForm.controls['effectiveDate'].touched
                  "
                >
                  Effective Date is a required field
                </small>
              </div>
            </div>

            <div class="col-md-12 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Impact</div>
                <input
                  formControlName="impact"
                  type="text"
                  class="form-control form-control-sm mat-autodd-input"
                  matInput
                  [matAutocomplete]="impactAuto"
                  required
                />
                <mat-autocomplete #impactAuto="matAutocomplete">
                  <mat-option
                    *ngFor="let option of searchedImpacts"
                    [value]="option.value"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
                <small
                  class="text-danger col-md-12 p-0 mt-2"
                  *ngIf="
                    !actionManagerForm.controls['impact'].value &&
                    actionManagerForm.controls['impact'].touched
                  "
                >
                  Impact is a required field
                </small>
              </div>
            </div>

            <div class="col-md-12 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Assessment</div>
                <input
                  formControlName="assessment"
                  type="text"
                  class="form-control form-control-sm mat-autodd-input"
                  matInput
                  [matAutocomplete]="assessmentAuto"
                  required
                />
                <mat-autocomplete #assessmentAuto="matAutocomplete">
                  <mat-option
                    *ngFor="let option of searchedAssessments"
                    [value]="option.value"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
                <small
                  class="text-danger col-md-12 p-0 mt-2"
                  *ngIf="
                    !actionManagerForm.controls['assessment'].value &&
                    actionManagerForm.controls['assessment'].touched
                  "
                >
                  Assessment is a required field
                </small>
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-sm float-right"
            id="register-btn"
          >
            Submit
          </button>
          <span
            class="float-right mt-1 mr-2"
            *ngIf="response"
            [ngClass]="isError ? 'text-danger' : 'text-success'"
            >{{ response }}</span
          >
        </form>
      </div>
    </div>

    <hr />

    <div class="card" [ngClass]="user.planType >= 1 ? '' : 'text-disabled'">
      <div class="disabled-cont" *ngIf="user.planType < 1"></div>
      <div class="card-header text-header">
        <span class="fa fa-list"></span> Impact of Regulation
      </div>
      <app-progress-bar [isLoading]="isLoadingRegDetail"></app-progress-bar>
      <div class="card-body">
        <div class="mb-2">
          <a
            href="#"
            [ngClass]="user.planType >= 1 ? '' : 'text-disabled'"
            style="pointer-events: none"
            >Linked Rules</a
          >
        </div>
        <div
          class="table-responsive box-shadow"
          [ngClass]="user.planType >= 1 ? '' : 'overflow-none'"
        >
          <table class="table table-fixed mb-0" id="rules-table">
            <thead>
              <tr>
                <th class="col-lg-4" (click)="sortLinkedRules('Country')">
                  Country
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedRulesSorting.SortKey === 'Country' &&
                        !linkedRulesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedRulesSorting.SortKey === 'Country' &&
                        linkedRulesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
                <th class="col-lg-4" (click)="sortLinkedRules('Regulator')">
                  Regulator
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedRulesSorting.SortKey === 'Regulator' &&
                        !linkedRulesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedRulesSorting.SortKey === 'Regulator' &&
                        linkedRulesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
                <th class="col-lg-4" (click)="sortLinkedRules('Title')">
                  Title
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedRulesSorting.SortKey === 'Title' &&
                        !linkedRulesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedRulesSorting.SortKey === 'Title' &&
                        linkedRulesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
              </tr>
            </thead>
            <tbody
              [ngClass]="user.planType >= 1 ? '' : 'overflow-none'"
              *ngIf="linkedRules.length !== 0"
            >
              <tr *ngFor="let rule of linkedRules">
                <td class="col-lg-4">{{ rule.Country }}</td>
                <td class="col-lg-4">{{ rule.Regulator }}</td>
                <td class="col-lg-4">
                  <span
                    class="text-link"
                    (click)="routeToChangeViewer(rule.Title)"
                    >{{ rule.Title }}</span
                  >
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="linkedRules.length === 0">
              <tr>
                <td colspan="3">No linked rules found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--card-->
    <hr />
    <div class="card" [ngClass]="user.planType >= 1 ? '' : 'text-disabled'">
      <div class="disabled-cont" *ngIf="user.planType < 1"></div>
      <div class="card-body">
        <div class="mb-2">
          <a
            [ngClass]="user.planType >= 1 ? '' : 'text-disabled'"
            href="#"
            style="pointer-events: none"
            >Linked Policies, Procedures, Risks & Control</a
          >
        </div>
        <div
          class="table-responsive box-shadow"
          [ngClass]="user.planType >= 1 ? '' : 'overflow-none'"
        >
          <table
            class="table table-fixed mb-0"
            id="policy-table"
            style="min-width: 900px"
          >
            <thead>
              <tr>
                <th class="col-lg-2" (click)="sortLinkedPolicies('Name')">
                  Name
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedPoliciesSorting.SortKey === 'Name' &&
                        !linkedPoliciesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedPoliciesSorting.SortKey === 'Name' &&
                        linkedPoliciesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
                <th class="col-lg-1" (click)="sortLinkedPolicies('Id')">
                  ID
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedPoliciesSorting.SortKey === 'Id' &&
                        !linkedPoliciesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedPoliciesSorting.SortKey === 'Id' &&
                        linkedPoliciesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
                <th class="col-lg-1" (click)="sortLinkedPolicies('Type')">
                  Type
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedPoliciesSorting.SortKey === 'Type' &&
                        !linkedPoliciesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedPoliciesSorting.SortKey === 'Type' &&
                        linkedPoliciesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
                <th class="col-lg-2" (click)="sortLinkedPolicies('Owner')">
                  Owner
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedPoliciesSorting.SortKey === 'Owner' &&
                        !linkedPoliciesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedPoliciesSorting.SortKey === 'Owner' &&
                        linkedPoliciesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
                <th
                  class="col-lg-2"
                  (click)="sortLinkedPolicies('LineOfBusiness')"
                >
                  Line of Business
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedPoliciesSorting.SortKey === 'LineOfBusiness' &&
                        !linkedPoliciesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedPoliciesSorting.SortKey === 'LineOfBusiness' &&
                        linkedPoliciesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
                <th class="col-lg-2" (click)="sortLinkedPolicies('Functions')">
                  Functions
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedPoliciesSorting.SortKey === 'Functions' &&
                        !linkedPoliciesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedPoliciesSorting.SortKey === 'Functions' &&
                        linkedPoliciesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
                <th class="col-lg-2" (click)="sortLinkedPolicies('Locations')">
                  Locations
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-sort-asc':
                        linkedPoliciesSorting.SortKey === 'Locations' &&
                        !linkedPoliciesSorting.IsDesc,
                      'fa-sort-desc':
                        linkedPoliciesSorting.SortKey === 'Locations' &&
                        linkedPoliciesSorting.IsDesc
                    }"
                    aria-hidden="true"
                  ></i>
                </th>
              </tr>
            </thead>
            <tbody [ngClass]="user.planType >= 1 ? '' : 'overflow-none'">
              <tr *ngFor="let policy of linkedPolicies">
                <td class="col-lg-2">{{ policy.Name }}</td>
                <td class="col-lg-1">{{ policy.Id }}</td>
                <td class="col-lg-1">{{ policy.Type }}</td>
                <td class="col-lg-2">{{ policy.Owner }}</td>
                <td class="col-lg-2">{{ policy.LineOfBusiness }}</td>
                <td class="col-lg-2">{{ policy.Functions }}</td>
                <td class="col-lg-2">{{ policy.Locations }}</td>
              </tr>
            </tbody>
            <tbody
              [ngClass]="user.planType >= 1 ? '' : 'overflow-none'"
              *ngIf="linkedPolicies.length === 0"
            >
              <tr>
                <td colspan="7">
                  No linked internal policies, procedures, risks, controls found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="card">
      <div class="card-header text-header">
        <span class="fa fa-list"></span> Quick Tools
      </div>
      <div class="card-body">
        <div class="row">
          <!-- <div class="col-md-12 mb-2">
            <button class="btn btn-small pl-0 pr-0 text-purple" [disabled]="formData.invalid" (click)="saveRegulationActionDetail()"><span class="fa fa-home"></span>
              Submit</button>
          </div> -->
          <div class="col-md-12">
            <a
              [routerLink]="['/change-viewer']"
              routerLinkActive="router-link-active"
              class="text-danger cursor-pointer"
              ><span class="fa fa-close"></span> Close</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
